import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import produce from 'immer';

import {
    VerificationService,
    Locale,
    ViewModel,
    getLocaleSafely,
    FaqLinkComponent,
} from '@sheerid/jslib';


interface FormFooterProps {
    verificationService: VerificationService;
    children?: any;
}

const FormFooterComponent = ({ verificationService, children }: FormFooterProps) => {
    const { viewModel, updateViewModel } = verificationService;
    const locale: Locale = getLocaleSafely(viewModel);
    const privacyPolicyRef = React.useRef<any>({});
    const cleanupCommonTags = /(<div[^>]+>|<div>|<\/div>)|(<span[^>]+>|<span>|<\/span>)|(<p[^>]+>|<p>|<\/p>)/gm;

    // Store the footer message that the user was shown when the user submitted
    React.useEffect(() => {
        if (!privacyPolicyRef.current) {
            return;
        }
        const privacyPolicyText = privacyPolicyRef.current.innerHTML.replace(cleanupCommonTags, '');
        const updatedViewModel = produce(viewModel, (draft: ViewModel) => {
            if (!draft.metadata) {
                draft.metadata = {};
            }
            draft.metadata.submissionOptIn = privacyPolicyText;
        });

        updateViewModel(updatedViewModel);
    }, [privacyPolicyRef, locale]);

    return (
        <div className="sid-footer">
            <div>
                <div className="sid-footer__one" ref={privacyPolicyRef}>
                    {children ? children : (
                        <div>
                            <FormattedHTMLMessage
                                id="studentInfoShared"
                                defaultMessage=
                                    "Information entered here will be used for verification purposes and shared with Hulu. Verification service powered by SheerID."
                            />
                            <br />
                            <FaqLinkComponent verificationService={verificationService} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export { FormFooterComponent };
